'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.dayAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/dayAgo.js
// module id = 660
// module chunks = 0